import { IconVolume, IconVolumeOff } from '@tabler/icons-react';
import classNames from 'classnames';

import s from './jukebox-volume-control.module.scss';
import { useJukeboxVolumeStore } from '../../model/jukebox-volume.store';

/**
 * Регулятор громкости синхронного аудио (музыка / метроном).
 * Ползунок задаёт уровень музыки В МИКСЕ до кодирования — ведущий (монитор)
 * и все слушатели слышат одинаковую громкость.
 */
export const JukeboxVolumeControl = ({ kind, className }) => {
  const {
    musicVolume,
    metronomeVolume,
    setMusicVolume,
    setMetronomeVolume,
  } = useJukeboxVolumeStore();

  const value = kind === 'metronome' ? metronomeVolume : musicVolume;
  const setValue = kind === 'metronome' ? setMetronomeVolume : setMusicVolume;
  const muted = value === 0;

  return (
    <div className={classNames(s.volumeControl, className)}>
      <button
        type="button"
        className={s.iconBtn}
        onClick={() => setValue(muted ? 1 : 0)}
        title={muted ? 'Включить звук' : 'Выключить звук'}
      >
        {muted ? <IconVolumeOff size={16} /> : <IconVolume size={16} />}
      </button>
      <input
        type="range"
        min={0}
        max={100}
        value={Math.round(value * 100)}
        onChange={(e) => setValue(Number(e.target.value) / 100)}
        className={s.slider}
        aria-label="Громкость"
      />
    </div>
  );
};
